/**
 * D32/D35 — Home's fuzzy search, client-side over the already-loaded gate list. Matches on
 * **personal alias and default name** (never a site — D35 removed that layer), so a gate a
 * resident renamed is found by its alias and by its default name alike.
 */

function normalize(value: string): string {
  return value.trim().toLowerCase()
}

/**
 * A substring match first, then an in-order (non-contiguous) subsequence fallback — "grg" still
 * finds "Garage" — with no library and no per-keystroke network call.
 */
function fuzzyIncludes(needle: string, haystack: string): boolean {
  if (needle === '') return true
  if (haystack.includes(needle)) return true
  let i = 0
  for (let j = 0; j < haystack.length && i < needle.length; j += 1) {
    if (haystack[j] === needle[i]) i += 1
  }
  return i === needle.length
}

export function matchesGateSearch(
  query: string,
  gate: { readonly alias?: string; readonly defaultName: string },
): boolean {
  const q = normalize(query)
  if (q === '') return true
  return (
    fuzzyIncludes(q, normalize(gate.defaultName)) ||
    (gate.alias !== undefined && fuzzyIncludes(q, normalize(gate.alias)))
  )
}
